import React from "react";
import { Link } from "react-router-dom";
import { Embed } from "semantic-ui-react";
import { image } from "../../../../datos";

import "./GestionHumanaPages.scss";

export function GestionHumanaPages() {
  return (
    <div className="container mt-6 md:w-4/2 md:mx-auto md:flex md:justify-evenly">
      <div className="mx-4" data-aos="fade-down" data-aos-delay="800">
        <h2 className="text-4xl uppercase font-semibold my-2">Somos Catelli</h2>
        <p className="text-2xl text-justify">
          Te brindamos seguridad, Fomentamos el trabajo en equipo, Nos
          preocupamos pro desarrollar el talento humano,
          <span> Somos una familia</span>
        </p>

        <div className="mt-6">
          <Link
            className="btn bg-blue-800 py-4"
            to={"/recursohumano/formulario"}
          >
            Forma parte de nuestro equipo.
          </Link>
        </div>
      </div>
      <div
        className="md:h-auto md:w-full mt-4 mx-4"
        data-aos="fade-down"
        data-aos-delay="1000"
      >
        {/* videos */}
        <Embed id="PDHPxMf7_MY" source="youtube" placeholder={image.logo} />
      </div>
    </div>
  );
}
